import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { isNotUndefined } from "@faire/web--source/common/typescriptUtils";
import { Chevron } from "@faire/web--source/slate/icons/foundation/Chevron";
import { FormInputLabel } from "@faire/web--source/slate/Input";
import { Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import * as React from "react";
import { useTheme } from "styled-components";
import { MobileChevronWrapper, MobileInnerWrapper, MobileSelectWrapper, StyledSelect } from "../styles";
export var MobileDropdown = function(param) {
    var borderless = param.borderless, className = param.className, dataTestId = param.dataTestId, disabled = param.disabled, errorMessage = param.errorMessage, options = param.options, helper = param.helper, id = param.id, label = param.label, onOpen = param.onOpen, onSelect = param.onSelect, placeholder = param.placeholder, showErrorMessage = param.showErrorMessage, showErrorState = param.showErrorState, value = param.value;
    var _theme_input_label;
    var theme = useTheme();
    var isValueInOptions = options.some(function(option) {
        return option.value === value;
    });
    var validValue = isValueInOptions ? value : "";
    var handleSelectClick = React.useCallback(function(e) {
        onOpen === null || onOpen === void 0 ? void 0 : onOpen();
        e.preventDefault();
        e.stopPropagation();
    }, [
        onOpen
    ]);
    var _theme_input_label1, _theme_input_label_color, _theme_input_helper;
    return /*#__PURE__*/ _jsxs(MobileSelectWrapper, {
        className: className,
        children: [
            isNotUndefined(label) ? /*#__PURE__*/ _jsx(FormInputLabel, {
                $typography: _object_spread_props(_object_spread({}, (_theme_input_label1 = theme === null || theme === void 0 ? void 0 : theme.input.label) !== null && _theme_input_label1 !== void 0 ? _theme_input_label1 : {}), {
                    color: showErrorState ? "error" : (_theme_input_label_color = theme === null || theme === void 0 ? void 0 : (_theme_input_label = theme.input.label) === null || _theme_input_label === void 0 ? void 0 : _theme_input_label.color) !== null && _theme_input_label_color !== void 0 ? _theme_input_label_color : Core.text.default
                }),
                children: label
            }) : null,
            /*#__PURE__*/ _jsxs(MobileInnerWrapper, {
                $borderless: borderless,
                $showErrorState: showErrorState,
                $disabled: disabled,
                children: [
                    /*#__PURE__*/ _jsx(MobileChevronWrapper, {
                        children: /*#__PURE__*/ _jsx(Chevron, {
                            direction: "down",
                            color: disabled ? Core.icon.disabled : Core.icon.default,
                            width: "8",
                            height: "8",
                            strokeWidth: 2
                        })
                    }),
                    /*#__PURE__*/ _jsxs(StyledSelect, {
                        id: id,
                        "data-test-id": dataTestId,
                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                        // @ts-ignore used for tests, even though it's not a valid prop on select in some React versions.
                        placeholder: placeholder,
                        disabled: disabled,
                        onClick: handleSelectClick,
                        onChange: function(e) {
                            return onSelect(e.target.value);
                        },
                        value: validValue || "",
                        children: [
                            placeholder ? /*#__PURE__*/ _jsx("option", {
                                value: "",
                                disabled: true,
                                children: placeholder
                            }) : null,
                            options.map(function(option) {
                                return /*#__PURE__*/ _jsx("option", {
                                    "data-test-id": "dropdownItem_".concat(option.value),
                                    value: option.value,
                                    disabled: option.disabled,
                                    children: option.label
                                }, option.value);
                            })
                        ]
                    })
                ]
            }),
            helper && !showErrorMessage ? /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx(Spacer, {
                        size: 4
                    }),
                    /*#__PURE__*/ _jsx(Typography, _object_spread_props(_object_spread({
                        color: Core.text.subdued
                    }, (_theme_input_helper = theme === null || theme === void 0 ? void 0 : theme.input.helper) !== null && _theme_input_helper !== void 0 ? _theme_input_helper : {}), {
                        children: helper
                    }))
                ]
            }) : null,
            showErrorMessage ? /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx(Spacer, {
                        size: 4
                    }),
                    /*#__PURE__*/ _jsx(Typography, {
                        variant: "labelSansRegular",
                        color: Core.text.critical,
                        children: errorMessage
                    })
                ]
            }) : null
        ]
    });
};
